import cn from "classnames";
import {
  default as ReactCountryFlag,
  ReactCountryFlagProps,
} from "react-country-flag";
import { getCountryCode } from "shared/src/getCountryCode";

type FiatFlagProps = Omit<ReactCountryFlagProps, "countryCode"> & {
  countryCode?: string;
  currencyCode?: string | null;
};

export const FiatFlag = ({
  countryCode,
  currencyCode,
  className,
  style,
  ...props
}: FiatFlagProps) => {
  const resolvedCountryCode =
    countryCode ?? getCountryCode(currencyCode?.toUpperCase() ?? null);

  return (
    <ReactCountryFlag
      {...props}
      countryCode={resolvedCountryCode}
      className={cn(className, "rounded-full")}
      // NOTE (HJST): For some reason adding 'objectFit: cover' as tailwind className doesnt apply the styling
      style={{ objectFit: "cover", ...style }}
    />
  );
};
